import * as React from 'react';
import './addFilters.scss';
import { FiltersProps } from '../../../types/FilterProps';
import { Dropbox } from '../../Dropbox/dropbox';
import { SchemaFieldTypeahead } from '../../SchemaFieldTypeahead/schemaFieldTypeahead';
import { Add } from '../../Icon/icon';
import { FieldType } from '../../../enums/FieldType';
import { excludeEmptyFilters, SchemalessFilterSchema } from '../../../utils';

export const AddFilters = ({
  addFilter,
  addAnotherFilter,
  filters,
  defaultFilters,
  schemas
}: Pick<
  FiltersProps,
  'addFilter' | 'addAnotherFilter' | 'filters' | 'defaultFilters' | 'schemas'
>) => {
  const selected = (filters || []).map(f => f.field);
  const allSchemaFields = schemas?.reduce(
    (acc, s) => acc.concat(s?.props?.fields?.map(f => f.key)),
    SchemalessFilterSchema.props.fields.map(sf => sf.key)
  );
  const defFilters = defaultFilters?.filter(df => allSchemaFields.includes(df));
  const [showAll, setShowAll] = React.useState(false);
  return (
    <Dropbox
      className="add-filters"
      renderBox={setExpanded => (
        <SchemaFieldTypeahead
          inline
          flat
          isChecked={f => selected.includes(f.key)}
          canAddAnother={fp => {
            const currFilterOccurrences = filters?.filter(
              f => f.field == fp.key
            )?.length;
            if (!currFilterOccurrences) {
              return false;
            }
            const populatedFilters = excludeEmptyFilters(filters);
            const populatedFilterOccurrences = populatedFilters?.filter(
              pf => pf.field == fp.key
            )?.length;

            return currFilterOccurrences == populatedFilterOccurrences;
          }}
          includeSchemalessFilters
          excludeFields={s => {
            if (s.excludeFromView) {
              return true;
            }
            if (s.key == 'Item.companionBy') return true;
            if (s.parentField == 'thisFieldShouldNeverShow') return true;
            if (!showAll && defFilters?.length) {
              if (!defFilters.includes(s.key)) return true;
            }
            if (s.fieldType == FieldType.custom) {
              return true;
            }
            return false;
          }}
          onSelectField={f => {
            addFilter({ field: f.key });
            setExpanded(false);
          }}
          onSelectAddAgain={f => {
            addAnotherFilter({
              field: f.key,
              uuid: Math.random().toString(10)
            });
            setExpanded(false);
          }}
        >
          {!!defFilters?.length && (
            <div className="typeahead-popular-fields">
              <div></div>
              <div onClick={() => setShowAll(!showAll)}>
                See {showAll ? 'Less' : 'All'}
              </div>
            </div>
          )}
        </SchemaFieldTypeahead>
      )}
    >
      <Add /> Add Filter
    </Dropbox>
  );
};
